import { render } from "./PostSkeleton.vue?vue&type=template&id=c2bc8e80&scoped=true"
import script from "./PostSkeleton.vue?vue&type=script&lang=js"
export * from "./PostSkeleton.vue?vue&type=script&lang=js"

import "./PostSkeleton.vue?vue&type=style&index=0&id=c2bc8e80&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2bc8e80"]])

export default __exports__